"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webjs_sdk_1 = require("@aria/webjs-sdk");
const config_1 = require("config");
const EnvironmentHelper_1 = require("./EnvironmentHelper");
var SilentLoginStatus;
(function (SilentLoginStatus) {
    SilentLoginStatus["Success"] = "success";
    SilentLoginStatus["Fail"] = "fail";
})(SilentLoginStatus = exports.SilentLoginStatus || (exports.SilentLoginStatus = {}));
const prefix = 'ui_';
var CommonProperty;
(function (CommonProperty) {
    CommonProperty["SkypeId"] = "UserInfo.SkypeId";
    CommonProperty["ThreadId"] = "Meeting.ThreadId";
    CommonProperty["InviteSkypeId"] = "Invite.SkypeId";
    CommonProperty["BotId"] = "Bot.BotId";
    CommonProperty["EntryPoint"] = "Page.EntryPoint";
    CommonProperty["CorrelationId"] = "Page.CorrelationId";
    CommonProperty["Source"] = "Page.Source";
    CommonProperty["Profile"] = "Profile.SkypeId";
})(CommonProperty = exports.CommonProperty || (exports.CommonProperty = {}));
class LoggerHelper {
    constructor() {
        this._logger = webjs_sdk_1.AWTLogManager.getLogger();
        this._commonProperties = {};
        this._sessionStartDate = new Date();
        this._wasLoggedIn = false;
        this._wasUnifiedView = false;
        this.getSessionId = () => this._logger.getSessionId();
        this.error = (event, priority = webjs_sdk_1.AWTEventPriority.Normal) => {
            this._log(event, priority, 'error', 'Error');
        };
        this.network = (event, priority = webjs_sdk_1.AWTEventPriority.Normal) => {
            this._log(event, priority, 'network_event', 'Network');
        };
        this.navigation = (event, priority = webjs_sdk_1.AWTEventPriority.Normal) => {
            this._log(event, priority, 'navigation', 'Navigation');
        };
        this.action = (event, priority = webjs_sdk_1.AWTEventPriority.Normal) => {
            this._log(event, priority, 'action', 'Action');
        };
        this.silentLogin = (event, priority = webjs_sdk_1.AWTEventPriority.Normal) => {
            this._log(event, priority, 'silent_login', 'SilentLogin');
        };
        this.sessionStarted = (event, priority = webjs_sdk_1.AWTEventPriority.Normal) => {
            this._sessionStartDate = new Date();
            this._wasLoggedIn = event.wasPreLoggedin;
            this._wasUnifiedView = event.useUnifiedView;
            this._log(event, priority, 'session_started', 'SessionStarted');
        };
        this.sessionIntermediateStep = (event, priority = webjs_sdk_1.AWTEventPriority.Normal) => {
            event.wasLoggedIn = this._wasLoggedIn;
            event.useUnifiedView = this._wasUnifiedView;
            this._log(event, priority, 'session_intermediate', 'SessionIntermediateEvent');
        };
        this.sessionFinished = (event, priority = webjs_sdk_1.AWTEventPriority.Normal) => {
            const diffMs = (new Date().valueOf() - this._sessionStartDate.valueOf());
            event.sessionDurationInMs = diffMs;
            event.wasLoggedIn = this._wasLoggedIn;
            event.useUnifiedView = this._wasUnifiedView;
            this._log(event, priority, 'session_finished', 'SessionFinished');
        };
        this.setName = (eventProperties, name) => {
            eventProperties.setName(prefix + name);
            eventProperties.setType(name);
        };
        this.setCommonProperties = (eventProperties) => {
            Object.keys(this._commonProperties).forEach((key) => {
                const property = this._commonProperties[key];
                if (property.piiKind) {
                    eventProperties.setPropertyWithPii(property.key, property.value, property.piiKind);
                }
                else {
                    eventProperties.setProperty(property.key, property.value);
                }
            });
            eventProperties.setProperty('DeviceInfo.Custom.Os', EnvironmentHelper_1.os);
            eventProperties.setProperty('DeviceInfo.Custom.Browser', EnvironmentHelper_1.browser);
            eventProperties.setProperty('DeviceInfo.Custom.DeviceType', EnvironmentHelper_1.deviceType);
            eventProperties.setProperty('Config.Env', config_1.default.env);
        };
        this.setProperties = (eventProperties, properties, propertyPrefix) => {
            Object.keys(properties).forEach((property) => {
                if (typeof properties[property] === 'object' && properties[property]) {
                    this.setProperties(eventProperties, properties[property], propertyPrefix + '.' + property);
                }
                else {
                    eventProperties.setProperty(propertyPrefix + '.' + property, properties[property]);
                }
            });
        };
        this._onError = (message, file, line, col, error) => {
            this._log({
                message,
                file,
                line,
                col,
                error,
            }, webjs_sdk_1.AWTEventPriority.Normal, 'js_onerror', 'Error');
        };
    }
    init() {
        webjs_sdk_1.AWTLogManager.initialize(config_1.default.logging.ariaTenant, {
            canSendStatEvent: () => false,
            enableAutoUserSession: true,
        });
        window.onerror = this._onError;
        // Current implementation of the flushAndTeardown method has wrong context when used as callback
        // therefore asynchronous pending events would be lost, let's fix it
        window.removeEventListener('beforeunload', webjs_sdk_1.AWTLogManager.flushAndTeardown);
        window.addEventListener('beforeunload', webjs_sdk_1.AWTLogManager.flushAndTeardown.bind(webjs_sdk_1.AWTLogManager));
    }
    initCommonProperty(property) {
        this._commonProperties[property.key] = property;
    }
    _log(event, priority, name, propertyPrefix) {
        const eventProperties = new webjs_sdk_1.AWTEventProperties();
        eventProperties.setEventPriority(priority);
        this.setName(eventProperties, name);
        this.setCommonProperties(eventProperties);
        this.setProperties(eventProperties, event, propertyPrefix);
        this._logger.logEvent(eventProperties);
    }
}
exports.logger = new LoggerHelper();
